export const GOOGLE_MAPS_API_KEY='AIzaSyCoOuJP-Op6BN_LadCNwGEBfbGaGSClMs8';
export const API_BASE_URL='https://admin.stark-wie-ein-baum.de';
